import { useEffect, useMemo } from "react";
import { useThree } from "@react-three/fiber";
import { prefilterEnvironment } from "./prefilterEnvironment";

export function useRendererEnvironment(texture, enabled) {
  const renderer = useThree((state) => state.gl);
  const target = useMemo(() => enabled ? prefilterEnvironment(renderer, texture) : null, [renderer, texture, enabled]);
  useEffect(() => () => target?.dispose(), [target]);
  return target?.texture ?? texture;
}
